import { circuitDate } from './calendar';
import { spacedCycleForDate } from './era';

/**
 * The day's setting: which part of Italy the circuit is in. It changes only how the world looks (and the
 * circuit's name): never the road, the car or anything the race runs on, so laps, ghosts and boards don't
 * depend on it. The look of each is in render/look.ts; this is just which day gets which (no three.js here,
 * so the server can name circuits the same way).
 */
export type SettingId = 'tuscany' | 'liguria' | 'dolomites' | 'sicily';
export const SETTING_IDS: readonly SettingId[] = ['tuscany', 'liguria', 'dolomites', 'sicily'];

/** Their names, for the poster. */
export const SETTING_NAMES: Record<SettingId, string> = { tuscany: 'Tuscany', liguria: 'Liguria', dolomites: 'Dolomites', sicily: 'Sicily' };

/**
 * The first day with settings. Days before are Tuscany (as they always were: their circuits keep their
 * names). Moved to the day after going live when it ships.
 */
export const SETTINGS_FROM = '2026-10-06';

/** The region a day races in: its circuit's (a day that races another date's circuit, calendar.ts, has its region too). */
export function settingForDate(date: string): SettingId {
  return settingOfCircuit(circuitDate(date));
}

/** The region a circuit was made for, by the date it was made for: each setting comes round once every four days, in a new order each time, and not again within three. */
export function settingOfCircuit(date: string): SettingId {
  if (date < SETTINGS_FROM) return 'tuscany';
  return spacedCycleForDate(SETTING_IDS, 'setting', date, 3, SETTINGS_FROM);
}

export function isSettingId(v: string | null | undefined): v is SettingId {
  return !!v && (SETTING_IDS as readonly string[]).includes(v);
}
